import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {faArrowsAltH, faCog, faShieldAlt, faTv, faUser, faUserCircle} from '@fortawesome/free-solid-svg-icons';
import {UserService} from 'src/app/core/services/user.service';
import {Store} from "@ngxs/store";
import {Logout, ToggleWidescreen} from 'src/app/shared/state/session-state.actions';
import {SessionState} from 'src/app/shared/state/session-state';
import {RouterLink} from '@angular/router';
import {HeaderSearchComponent} from '../../../components/header-search/header-search.component';
import {NgbDropdown, NgbDropdownAnchor, NgbDropdownItem, NgbDropdownMenu} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [RouterLink, HeaderSearchComponent, NgbDropdown, NgbDropdownAnchor, FontAwesomeModule, NgbDropdownMenu, NgbDropdownItem],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {

  private store = inject(Store);
  public userService = inject(UserService);

  public user = this.store.selectSignal(SessionState.user);

  readonly isAdmin = toSignal(this.userService.hasRole('Admin'), {initialValue: false});
  readonly canEditLink = toSignal(this.userService.hasAbility('edit-link'), {initialValue: false});
  readonly canEditAffiliate = toSignal(this.userService.hasAbility('edit-affiliate'), {initialValue: false});
  readonly canUseCidUpdater = toSignal(this.userService.hasAbility('cid-updater'), {initialValue: false});

  public faCog = faCog;
  public faUser = faUser;
  public faShieldAlt = faShieldAlt;
  public faUserCircle = faUserCircle;
  public faArrowsAltH = faArrowsAltH;
  public faTv = faTv;

  public collapsed = false;

  logout(): void {
    this.store.dispatch(Logout);
  }

  public toggleWidescreen(): void {
    this.store.dispatch(ToggleWidescreen);
  }

  click(): void {
    this.collapsed = true;
  }
}
